import "regenerator-runtime/runtime";
import FormatInterface from './FormatInterface';

export default class ImageWithLinkFormat extends FormatInterface {
    async render() {
        return await this.getTemplate();
    }

    callback() {
        return '';
    }

    getTemplate() {
        return `<a href="${this.params.link}"  target="_blank" style="display: block;">
                    <div style="width:100%; 
                        height: ${this.params.container.height}px; 
                        background-repeat: no-repeat; 
                        background: url(${this.params.imgUrl}); 
                        background-repeat-y: no-repeat; 
                        background-color:${this.params.color !== undefined?this.params.color:'transparent'}; 
                        background-size: 100%;" >                             
                    </div>   
                </a>`;
    }
}
